import { Room, RoomEvent, MatrixEvent } from 'matrix-js-sdk';
import { matrixClient } from '../../client';
import { Log } from '@fanfanlo';
import { messageUtils } from '../../message/messageUtils';
import { IMatrixMessage } from '../../message/types';
const fileLogger = new Log(false, 'im.client.room.handlers.Room.timeline');
// fileLogger.childrenPaused = true;
// fileLogger.pause = true;
function onRoomTimeline(event: MatrixEvent, room?: Room, toStartOfTimeline?: boolean, removed?: boolean, data?: any) {
    const logger = fileLogger.sub(false, 'onRoomTimeline_fn');
    logger.pause = true;
    logger.log('onRoomTimeline', event, room, toStartOfTimeline, removed, data);
    // 只处理新增的消息，不处理历史消息
    if (toStartOfTimeline || removed) {
        logger.log('onRoomTimeline end', event, room, toStartOfTimeline, removed, data);
        return;
    }
    if(!room){
        logger.log('onRoomTimeline end', event, room, toStartOfTimeline, removed, data);
        return;
    }

    // 获取事件类型
    const eventType = event.getType();
    const roomId = room.roomId;

    // 只处理消息事件
    if (eventType !== 'm.room.message') {
        logger.log('onRoomTimeline end', event, room, toStartOfTimeline, removed, data);
        return;
    }

    // 创建 IMatrixMessage 对象
    const message: IMatrixMessage = {
        event_id: event.getId() || '',
        sender: event.getSender() || '',
        content: event.getContent() || {},
        origin_server_ts: event.getTs() || Date.now(),
        type: eventType,
        unsigned: {
            age: event.getAge() || 0,
            transaction_id: event.getTxnId() || undefined,
            replaces_event_id: event.getContent()['m.relates_to']?.event_id || undefined
        }
    };

    // 确保必要字段存在
    if (!message.event_id || !message.sender || !message.content) {
        logger.log('Invalid message data', message);
        return;
    }

    // 添加消息到本地状态
    messageUtils.addMessage(roomId, message);
    logger.log('onRoomTimeline end', event, room, toStartOfTimeline, removed, data);
}

export const roomTimelineHandler = {
    init() {
        const logger = fileLogger.sub(false, 'roomTimelineHandler_init_fn');
        logger.pause = true;
        logger.log('roomTimelineHandler.init');
        // 添加时间线事件监听器
        matrixClient.clientOnEventDispatcher.on(RoomEvent.Timeline, onRoomTimeline);
    },
};